import { h } from "./dom";

export interface ModalAction {
  label: string;
  primary?: boolean;
  danger?: boolean;
  onClick: () => void;
}

export function showModal(
  root: HTMLElement,
  title: string,
  body: string | HTMLElement,
  actions: ModalAction[] = [{ label: "OK", primary: true, onClick: () => {} }],
) {
  const overlay = h("div", { class: "modal" }, []);
  const card = h("div", { class: "panel card" }, [h("h2", {}, [title])]);

  const bodyEl = typeof body === "string" ? h("p", {}, [body]) : body;
  card.appendChild(bodyEl);

  const actRow = h("div", { class: "actions" }, []);
  for (const a of actions) {
    actRow.appendChild(
      h(
        "button",
        {
          class: `btn ${a.primary ? "primary" : ""} ${a.danger ? "danger" : ""}`,
          onclick: () => {
            a.onClick();
            overlay.remove();
          },
        },
        [a.label],
      ),
    );
  }
  card.appendChild(actRow);
  overlay.appendChild(card);
  root.appendChild(overlay);
  return () => overlay.remove();
}
